import axios, { AxiosResponse } from 'axios'
import { Response } from '@/_metronic/helpers'
import {
  RepartitionData,
  VisitorEvolutionData,
  ActiveEvolutionData,
  Indicators,
  initialIndicators
} from './_models'

const BASE_URL = '/p2c/reports/customer'

// eslint-disable-next-line
const formatParams = (params?: Record<string, any>): Record<string, any> => {
  if (!params) return {};

  const formatted = Object.fromEntries(
    Object.entries(params).map(([key, value]) => {
      if (value instanceof Date) {
        const year = value.getFullYear();
        const month = String(value.getMonth() + 1).padStart(2, '0');
        const day = String(value.getDate()).padStart(2, '0');

        return [key, `${year}-${month}-${day}`];
      }
      return [key, value];
    })
  );

  return formatted;
};

interface IParams {
  from: Date;
  to: Date;
  timezone: string;
}

export const getActiveRepartition = async (params: IParams & { _new: boolean }): Promise<Array<RepartitionData>> => {
  const { _new, ...rest } = params
  return axios
    .get(`${BASE_URL}/active-repartition`, { params: formatParams({ ...rest, new: _new }) })
    .then((d: AxiosResponse<Response<Array<RepartitionData>>>) => d.data)
    .then((d: Response<Array<RepartitionData>>) => d.data || [])
}

/**
 * getVisitorsRepartition.
  * @returns { Promise<Array<RepartitionData>>}
 */
export const getVisitorsRepartition = async (params: IParams): Promise<Array<RepartitionData>> => {
  return axios
    .get(`${BASE_URL}/visitors-repartition`, { params: formatParams(params) })
    .then((d: AxiosResponse<Response<Array<RepartitionData>>>) => d.data)
    .then((d: Response<Array<RepartitionData>>) => d.data || [])
}

/**
 * getEmailsRepartition.
 * @returns {Promise<Array<RepartitionData>>}
 */
export const getEmailsRepartition = async (params: IParams): Promise<Array<RepartitionData>> => {

  return axios
    .get(`${BASE_URL}/emails-repartition`, { params: formatParams(params) })
    .then((d: AxiosResponse<Response<Array<RepartitionData>>>) => d.data)
    .then((d: Response<Array<RepartitionData>>) => d.data || [])
}

/**
 * getRefererRepartition.
 *
 * @returns {Promise<Array<RepartitionData>>}
 */
export const getRefererRepartition = async (params: IParams): Promise<Array<RepartitionData>> => {

  return axios
    .get(`${BASE_URL}/referer-repartition`, { params: formatParams(params) })
    .then((d: AxiosResponse<Response<Array<RepartitionData>>>) => d.data)
    .then((d: Response<Array<RepartitionData>>) => d.data || [])
}

/**
 * getVisitorEvolution.
 *
 * @returns {Promise<Array<VisitorEvolutionData>>}
 */
export const getVisitorEvolution = async (params: IParams & { pad: string }): Promise<Array<VisitorEvolutionData>> => {
  return axios
    .get(`${BASE_URL}/visitors-evolution/`, { params: formatParams(params) })
    .then((d: AxiosResponse<Response<Array<VisitorEvolutionData>>>) => d.data)
    .then((d: Response<Array<VisitorEvolutionData>>) => d.data || [])
}

export const getActiveEvolution = async (params: IParams & { pad: string }): Promise<Array<ActiveEvolutionData>> => {
  return axios
    .get(`${BASE_URL}/active-evolution`, { params: formatParams(params) })
    .then((d: AxiosResponse<Response<Array<ActiveEvolutionData>>>) => d.data)
    .then((d: Response<Array<ActiveEvolutionData>>) => d.data || [])
}

export const getIndicators = async (params: IParams): Promise<Indicators> => {
  return axios
    .get(`${BASE_URL}/indicators`, { params: formatParams(params) })
    .then((d: AxiosResponse<Response<Indicators>>) => d.data)
    .then((d: Response<Indicators>) => d.data || initialIndicators)
}
